// src/components/ImageSlider.jsx
import React from "react";
import Slider from "react-slick";
import "./ImageSlider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderImages = [
  
    { src: "new1.jpg", alt: "Cashew Nuts" },
     { src: "new2.jpg", alt: "Cashew Nuts" },
     { src: "logo23.jpg", alt: "Cashew Nuts" },
   { src: "logo23.jpg", alt: "Cashew Nuts" },
    { src: "logo24.jpg", alt: "Cashew Nuts" },
  { src: "logo1.jpg", alt: "Cashew Nuts" },
   { src: "new4.jpg", alt: "Cashew Nuts" },
     { src: "logo7.jpg", alt: "Cashew Nuts" },
      { src: "logo6.jpg", alt: "Cashew Nuts" },
      { src: "slide3.jpg", alt: "Cashew Farm" },
  { src: "mar.jpg", alt: "Cashew Farm" },
   { src: "edu.jpg", alt: "Cashew Farm" },
    { src: "medic.jpg", alt: "Cashew Farm" },
     { src: "elder.avif", alt: "Cashew Farm" },
     { src: "logo10.jpg", alt: "Cashew Farm" },
  
];

const ImageSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    
  <div className="slider-outer-wrapper">  {/* add this wrapper */}
 
    <Slider {...settings}>
      {sliderImages.map((image, index) => (
        <div key={index}>
          <img src={image.src} alt={image.alt} className="slider-image" />
        </div>
      ))}
    </Slider>
  </div>


  );
};

export default ImageSlider;
